import React, { FunctionComponent } from 'react';
import { PersonShowProps, PersonShowState } from './types';
import { PersonShowSidebar } from '../../organisms/personShowSidebar';
import { PersonShowMain } from '../../organisms/personShowMain';
import { PersonShowModal } from '../../organisms/personShowModal'
import { PersonShowHistories } from '../../organisms/personShowHistories';
import { PersonShowDetails } from '../../organisms/personShowDetails';
import { Flash } from '../../atoms/flash';
import { OccupationItem, PreferredOccupationItem } from '../../../types/personShow';
import { SelectedStatus } from '../../../types/entries';
import { ApplyItem, EventItem } from '../../organisms/personShowDetails/types';

type Props = PersonShowProps & {
  isPc: boolean;
  state: PersonShowState;
  showOffline011Banner: boolean;
  handleOpenModal: (target: string, title: string) => void;
  handleRequestResume: (type: string) => void;
  handleFetchSidebarDetails: () => void;
  handleUploadIcon: (file: File) => void;
  handleFetchDetails: () => void;
  handleUpdate: (target: string, deleted: boolean, overrideValue?: any) => void;
  onChangedBody: (name: string, value: any) => void;
  onChangeClickTarget: (value: number) => void;
  handleSendRequest: () => void;
  handleLike: () => void;
  insertFlashScout: () => void;
  handleDeleteHistories: () => void;
  selected_statuses: SelectedStatus[];
  // Memo props for company view
  memo: string;
  applies: ApplyItem[];
  events: EventItem[];
  isMemoModalOpen: boolean;
  handleMemoChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleOpenMemoModal: () => void;
  handleCloseMemoModal: () => void;
  handleSelectionStatusChanged: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  fetchValue: (selectionStatus: string, processingSelectionStatus: string) => string;
};

export const Presentation: FunctionComponent<Props> = ({
    state,
    isPc,
    showOffline011Banner,
    personId,
    logoPc,
    logoSp,
    noIconPersonImg,
    instagramIcon,
    twitterIcon,
    xIcon,
    penIconImg,
    offline011,
    unCompletedProfile,
    birthdayList,
    birthdayListStart,
    startYearList,
    endYearList,
    graduationList,
    careerEmploymentTypes,
    messageBoxId,
    isAllowedToScout,
    isMinimum,
    isSuccessPlan,
    isAllowedToSendScout,
    isOneYearPassed,
    isShow,
    fromPage,
    recentlyRegistered,
    loadingImagePath,
    isHidden,
    isAlreadyConnected,
    isNotRequested,
    isStudent,
    isNotRequestedResume,
    isNotRequestedJobResume,
    positions,
    handleOpenModal,
    handleRequestResume,
    handleFetchSidebarDetails,
    handleUploadIcon,
    handleFetchDetails,
    handleUpdate,
    onChangedBody,
    onChangeClickTarget,
    handleSendRequest,
    handleLike,
    insertFlashScout,
    handleDeleteHistories,
    selected_statuses,
    memo,
    applies,
    events,
    isMemoModalOpen,
    handleMemoChange,
    handleOpenMemoModal,
    handleCloseMemoModal,
    handleSelectionStatusChanged,
    fetchValue,
}) => {
  return (
    <>
      {fromPage === 'companyShow' && recentlyRegistered &&
        <Flash
          flashType='info'
          recently={recentlyRegistered.registerdDate}
          flashMessage='登録が1週間以内のためプロフィールが十分に記入されていない可能性があります'
          type='personShow'
        />
      }
      {state.flash &&
        <Flash
          flashType={state.flashType}
          flashMessage={state.flashMessage}
          type='personShow'
        />
      }
      <main className='person__show'>
        <PersonShowSidebar
          isSuccessPlan={isSuccessPlan}
          isPc={isPc}
          personId={personId}
          noIconPersonImg={noIconPersonImg}
          instagramIcon={instagramIcon}
          twitterIcon={twitterIcon}
          xIcon={xIcon}
          penIconImg={penIconImg}
          handleOpenModal={handleOpenModal}
          handleFetchSidebarDetails={handleFetchSidebarDetails}
          icon={state.icon}
          fullName={state.name}
          follows={state.follows}
          gender={state.gender}
          location={state.location}
          birthday={state.birthday}
          age={state.age}
          graduationYear={state.graduationYear}
          tel={state.tel}
          mail={state.mail}
          instagram={state.instagram}
          twitter={state.twitter}
          isShow={isShow}
          fromPage={fromPage}
          unCompletedProfile={unCompletedProfile}
          handleUploadIcon={handleUploadIcon}
          isStudent={isStudent}
          currentOccupations={state.currentOccupations as OccupationItem[]}
          salary={state.salary}
          offline011={offline011}
          showOffline011Banner={showOffline011Banner}
          positions={positions}
          resume={state.resume.resume}
          jobResume={state.job_resume.job_resume}
          memo={memo}
          isMemoModalOpen={isMemoModalOpen}
          handleMemoChange={handleMemoChange}
          handleOpenMemoModal={handleOpenMemoModal}
          handleCloseMemoModal={handleCloseMemoModal}
          isOneYearPassed={isOneYearPassed}
        />
        <PersonShowMain
          isPc={isPc}
          personId={personId}
          showOffline011Banner={showOffline011Banner}
          unCompletedProfile={unCompletedProfile}
          penIconImg={penIconImg}
          offline011={offline011}
          handleOpenModal={handleOpenModal}
          handleFetchDetails={handleFetchDetails}
          introduction={state.introduction}
          educationalHistories={state.educationalHistories}
          careerHistories={state.careerHistories}
          activity={state.activity}
          slogan={state.slogan}
          interests={state.interests}
          skills={state.skills}
          favoriteBrands={state.favoriteBrands}
          motivation={state.motivation}
          preferredLocations={state.preferredLocations}
          preferredOccupations={state.preferredOccupations as PreferredOccupationItem[]}
          preferenceConditions={state.preferenceConditions}
          onChangeClickTarget={onChangeClickTarget}
          isShow={isShow}
          isNotRequested={isNotRequested}
          fromPage={fromPage}
          handleSendRequest={handleSendRequest}
          isAllowedToScout={isAllowedToScout}
          isMinimum={isMinimum}
          isAllowedToSendScout={isAllowedToSendScout}
          isOneYearPassed={isOneYearPassed}
          loadingImagePath={loadingImagePath}
          handleLike={handleLike}
          insertFlashScout={insertFlashScout}
          messageBoxId={messageBoxId}
          resume={state.resume.resume}
          resumeUpdatedAt={state.resume.resumeUpdatedAt}
          job_resume={state.job_resume.job_resume}
          jobResumeUpdatedAt={state.job_resume.jobResumeUpdatedAt}
          isHidden={isHidden}
          isStudent={isStudent}
          tel={state.tel}
          mail={state.mail}
          instagram={state.instagram}
          twitter={state.twitter}
          handleFetchSidebarDetails={handleFetchSidebarDetails}
          isNotRequestedResume={isNotRequestedResume}
          isNotRequestedJobResume={isNotRequestedJobResume}
          handleRequestResume={handleRequestResume}
          isAlreadyConnected={isAlreadyConnected}
          memo={memo}
          handleMemoChange={handleMemoChange}
          careerEmploymentTypes={careerEmploymentTypes}
        />
        {fromPage === 'companyShow' && (
          <PersonShowDetails
            personId={personId}
            isPc={isPc}
            isOneYearPassed={isOneYearPassed}
            selected_statuses={selected_statuses}
            memo={memo}
            applies={applies}
            events={events}
            isMemoModalOpen={isMemoModalOpen}
            handleMemoChange={handleMemoChange}
            handleSelectionStatusChanged={handleSelectionStatusChanged}
            fetchValue={fetchValue}
            handleCloseMemoModal={handleCloseMemoModal}
          />
        )}
        {isShow &&
          <PersonShowModal
            isPc={isPc}
            handleOpenModal={handleOpenModal}
            onChangedBody={onChangedBody}
            title={state.modalTitle}
            target={state.target}
            isModal={state.isModal}
            resumeLoading={state.resumeLoading}
            introduction={state.introductionRaw}
            clickTarget={state.clickTarget}
            educationalHistories={state.educationalHistories}
            careerHistories={state.careerHistories}
            activity={state.activity}
            slogan={state.slogan}
            interests={state.interests}
            skills={state.skills}
            favoriteBrands={state.favoriteBrands}
            motivation={state.motivation}
            preferredLocations={state.preferredLocations}
            preferredOccupations={state.preferredOccupations as PreferredOccupationItem[]}
            preferenceConditions={state.preferenceConditions}
            startYearList={startYearList}
            birthdayListStart={birthdayListStart}
            endYearList={endYearList}
            birthdayList={birthdayList}
            name={state.name}
            follows={state.follows}
            gender={state.gender}
            location={state.location}
            birthday={state.birthday}
            age={state.age}
            graduationYear={state.graduationYear}
            tel={state.tel}
            mail={state.mail}
            instagram={state.instagram}
            twitter={state.twitter}
            graduationList={graduationList}
            personId={personId}
            resume={state.resume}
            job_resume={state.job_resume}
            handleUpdate={handleUpdate}
            handleDeleteHistories={handleDeleteHistories}
            currentOccupations={state.currentOccupations as OccupationItem[]}
            salary={state.salary}
            salaries={state.salaries}
            careerEmploymentTypes={careerEmploymentTypes}
          />
        }
        {fromPage === 'scout' &&
          <PersonShowHistories
            isPc={isPc}
            personId={personId}
            isShow={isShow}
            onHandleOpenModal={handleOpenModal}
          />
        }
      </main>
    </>
  );
};
